import { Box, SafeArea, Stack } from '@cellula/react';
import { tokens } from '@cellula/react-theme-patient';
import { BreakPoints, useBreakpoint } from '@cellula/react';
import styled, { css } from 'styled-components';
import { useSelectedEntrance } from '../../application/use_selected_entrance';
import { StickyTopBanner } from '@components/sticky_top_banner/sticky_top_banner.component';

interface ReceptionHomeLayoutProps {
	actionSection: JSX.Element[];
	heroSection: JSX.Element | null;
	aboutUsSection: JSX.Element | null;
	footerSection: JSX.Element | null;
}

const elements = {
	uniqueButtons: styled.div<{ buttonCount: number }>`
		display: grid;
		grid-column-gap: ${tokens.spacing.x1};
		grid-row-gap: ${tokens.spacing.x1};
		grid-template-columns: repeat(1, 1fr);
		width: 100%;

		${tokens.breakpointQuery.medium} {
			grid-column-gap: ${tokens.spacing.x3};
			grid-row-gap: ${tokens.spacing.x3};

			${({ buttonCount }) => {
				if (buttonCount === 1 || buttonCount % 2 === 0)
					return css`
						grid-template-columns: repeat(2, 1fr);
					`;

				return css`
					grid-template-columns: repeat(3, 1fr);
				`;
			}};
		}
	`,
};

export function ReceptionHomeLayout({
	aboutUsSection,
	heroSection,
	actionSection,
	footerSection,
	...rest
}: ReceptionHomeLayoutProps): JSX.Element {
	return (
		<Box background={tokens.color.bg.pageBrand} grow='1' {...rest}>
			<Stack asChild gap={tokens.spacing.x4}>
				<SafeArea maxWidth='1096px'>
					<Banner />
					{heroSection}

					<elements.uniqueButtons buttonCount={actionSection.length}>{actionSection}</elements.uniqueButtons>
					{aboutUsSection}
					{footerSection}
				</SafeArea>
			</Stack>
		</Box>
	);
}

function Banner(): JSX.Element | null {
	const breakpoint = useBreakpoint();
	const [unitNode] = useSelectedEntrance();

	if (breakpoint === BreakPoints.Large) return null;

	return <StickyTopBanner variant='leapScroll'>{unitNode?.name ?? ''}</StickyTopBanner>;
}
